import CareerPlanCard from './CareerPlanCard'
export default CareerPlanCard
